export const validation = {
  required: "Campo obrigatório",
  number: "Deve ser um número",
  numberPositive: "Número deve ser positivo",
  numberInteger: "Número deve ser inteiro",
};
